import { isBefore, isValid, parseISO } from 'date-fns'

import { normalizeRouteCodeToUnlocode } from '@dfds-pax/utils'

export const LoadDataFromParams = () => {
  const { searchParams } = new URL(window.location.href)

  const routeCode = normalizeRouteCodeToUnlocode(searchParams.get('routeCode') ?? '')
  const vehicleCode = (searchParams.get('vehicleCode') as string) || undefined
  const trailerCode = (searchParams.get('trailerCode') as string) || undefined
  const adults = Number(searchParams.get('adults') as string) || undefined
  const childrenAges = searchParams.getAll('chdAges')
  const pets = Number(searchParams.get('pets')) || undefined
  const outboundDate = searchParams.get('outboundDate') || undefined
  const homeboundDate = searchParams.get('homeboundDate') || undefined
  const oneWay = searchParams.get('oneWay') ? (searchParams.get('oneWay') as string) === 'true' : undefined
  // Public URL contract: also carries the shared travelSearchId; do not rename or remove (see README)
  const minibookId = searchParams.get('minibookId') || undefined
  const offerCode = searchParams.get('offerCode') || undefined
  const contentSource = searchParams.get('contentSource') || undefined

  return {
    queryData: {
      adults,
      childrenAges: childrenAges.map((age) => Number(age)),
      contentSource,
      homeboundDate:
        homeboundDate &&
        isValid(parseISO(homeboundDate)) &&
        !isBefore(parseISO(homeboundDate), outboundDate ? parseISO(outboundDate) : new Date())
          ? homeboundDate
          : undefined,
      minibookId,
      offerCode,
      oneWay: oneWay,
      outboundDate:
        outboundDate && !isBefore(parseISO(outboundDate), new Date()) && isValid(parseISO(outboundDate)) ? outboundDate : undefined,
      pets,
      routeCode,
      trailerCode,
      vehicleCode,
    },
  }
}

export const withContentSource = (params: URLSearchParams): URLSearchParams => {
  const { contentSource } = LoadDataFromParams().queryData
  if (contentSource) params.set('contentSource', contentSource)
  return params
}
